import NotificationListView from "@/views/admin/notifications/NotificationListView";

const meta = { middleware: ["auth"], roles: ["admin", "super_admin"] };

export default [
    {
        name: "admin.notifications",
        path: "notifications",
        component: NotificationListView,
        meta,
    },
];
